import { getErrorTypeFromUnknown } from "./ErrorParsers";

/**
 * Top-level framework error categories carried in `ErrorWithDebugInfos.type`.
 *
 * These are the broad transport-visible buckets. They are stable string
 * discriminators that travel across process and network boundaries.
 *
 * More specific framework failure reasons use `debugInfos.errorCode` and are
 * represented via `InternalErrors` when the type is `AtomErrors.InternalError`.
 */
export enum AtomErrors {
  CannotProvideAtom = "atom/cannot-provide",
  AtomIsNotRespawnable = "atom/not-respawnable",
  InternalError = "framework/internal",
  FailedToGetLock = "lock/failed-to-get",
  PersistenceServiceCriticalError = "persistence/critical",
  InsufficientPermission = "permission/insufficient",
  DeadLock = "lock/deadlock",
  LockTimedOut = "lock/timed-out",
}

const atomErrorTypes = new Set<string>(Object.values(AtomErrors));

export function getAtomErrorType(error: unknown): AtomErrors | undefined {
  const errorType = getErrorTypeFromUnknown(error);
  if (!errorType || !atomErrorTypes.has(errorType)) {
    return undefined;
  }

  return errorType as AtomErrors;
}
